// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
:root {
  --primary-dark: #4f46e5;
  --primary-light: #a5b4fc;
  --secondary-color: #10b981;
  --accent-color: #f59e0b;
  --text-primary: #1f2937;
  --text-secondary: #6b7280;
  --text-muted: #9ca3af;
  --bg-primary: #ffffff;
  --bg-secondary: #f8fafc;
  --bg-tertiary: #f1f5f9;
  --border-color: #e5e7eb;
  --border-light: #f3f4f6;
  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);
  --radius-sm: 6px;
  --radius-md: 8px;
  --radius-lg: 12px;
  --radius-xl: 16px;
}

.ext-cal-container {
  padding: 2rem;
  background: #f8f9fa;
}

.ext-cal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
}

.ext-cal-header-actions {
  display: flex;
  gap: 0.75rem;
}

.ext-cal-btn {
  padding: 0.625rem 1.25rem;
  border-radius: var(--radius-md);
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 0.875rem;
  border: 1px solid transparent;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}
.ext-cal-btn-primary {
  background: var(--primary-color);
  color: white;
  box-shadow: var(--shadow-sm);
}
.ext-cal-btn-primary:hover {
  background: linear-gradient(135deg, var(--primary-dark), #3730a3);
  box-shadow: var(--shadow-md);
  transform: translateY(-1px);
}
.ext-cal-btn-primary:active {
  transform: translateY(0);
}
.ext-cal-btn-outline {
  background: var(--bg-primary);
  border-color: var(--border-color);
  color: var(--text-secondary);
  box-shadow: var(--shadow-sm);
}
.ext-cal-btn-outline:hover {
  background: var(--bg-tertiary);
  border-color: var(--primary-light);
  color: var(--text-primary);
  transform: translateY(-1px);
}
.ext-cal-btn-sm {
  padding: 0.375rem 0.75rem;
  font-size: 0.75rem;
  font-weight: 500;
  border-radius: var(--radius-sm);
  white-space: nowrap;
}

.ext-cal-date-navigation {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  flex-wrap: wrap;
  gap: 1rem;
  background: var(--bg-primary);
  padding: 1rem 1.5rem;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
}

.ext-cal-month-controls {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

.ext-cal-date-arrows {
  display: flex;
  gap: 0.5rem;
}

.ext-cal-nav-btn {
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-md);
  padding: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.ext-cal-nav-btn:hover {
  background: var(--bg-tertiary);
  border-color: var(--primary-light);
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}
.ext-cal-nav-btn svg {
  width: 1.25rem;
  height: 1.25rem;
  color: var(--text-secondary);
}

.ext-cal-date-strip {
  display: flex;
  gap: 0.75rem;
  margin-bottom: 1rem;
  overflow-x: auto;
  justify-content: center;
  padding: 0.5rem;
  background: var(--bg-primary);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
}
.ext-cal-date-strip::-webkit-scrollbar {
  height: 6px;
}
.ext-cal-date-strip::-webkit-scrollbar-track {
  background: var(--bg-tertiary);
  border-radius: 3px;
}
.ext-cal-date-strip::-webkit-scrollbar-thumb {
  background: var(--primary-light);
  border-radius: 3px;
}
.ext-cal-date-strip::-webkit-scrollbar-thumb:hover {
  background: var(--primary-color);
}

.ext-cal-date-card {
  background: var(--bg-primary);
  padding: 0.7rem;
  border-radius: var(--radius-lg);
  text-align: center;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid transparent;
  min-width: 100px;
  position: relative;
  flex-shrink: 0;
}
.ext-cal-date-card:hover {
  background: var(--bg-tertiary);
  transform: translateY(-2px);
  box-shadow: var(--shadow-md);
}
.ext-cal-date-card.ext-cal-selected {
  background: var(--primary-color);
  color: white;
  border-color: var(--primary-color);
  transform: translateY(-2px);
}
.ext-cal-date-card.ext-cal-has-data {
  border-color: var(--primary-light);
}
.ext-cal-date-card.ext-cal-has-data:not(.ext-cal-selected) {
  background: linear-gradient(135deg, #fef7ff, #f3e8ff);
}

.ext-cal-date-day {
  font-size: 1rem;
  font-weight: 700;
  margin-bottom: 0.25rem;
  color: inherit;
}

.ext-cal-date-month {
  font-size: 0.75rem;
  font-weight: 600;
  margin-bottom: 0.25rem;
  opacity: 0.9;
  letter-spacing: 0.5px;
}

.ext-cal-date-weekday {
  font-size: 0.6875rem;
  opacity: 0.8;
  margin-bottom: 0.5rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.ext-cal-date-dot {
  width: 8px;
  height: 8px;
  background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));
  border-radius: 50%;
  margin: 0 auto;
  box-shadow: 0 2px 4px rgba(99, 102, 241, 0.3);
}
.ext-cal-selected .ext-cal-date-dot {
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
}

.ext-cal-select {
  padding: 0.625rem 1rem;
  border-radius: var(--radius-md);
  border: 1px solid var(--border-color);
  background: var(--bg-primary);
  font-size: 0.875rem;
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
}
.ext-cal-select:hover {
  border-color: var(--primary-light);
}
.ext-cal-select:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.ext-cal-actions {
  display: flex;
  gap: 0.75rem;
}

.ext-cal-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1rem;
  margin-bottom: 1rem;
  background: var(--bg-primary);
  padding: 1rem 1.5rem;
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-sm);
  position: relative;
}
.ext-cal-controls .ext-cal-sort-container {
  flex: 1 1;
  min-width: 200px;
  max-width: 300px;
}
.ext-cal-controls .ext-cal-sort-container .ext-cal-select {
  width: 100%;
  padding: 0.55rem 1rem;
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  background-color: #ffffff;
  color: #343a40;
  font-size: 0.875rem;
  min-width: 200px;
}
.ext-cal-controls .ext-cal-tabs {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  gap: 0.25rem;
  background: var(--bg-tertiary);
  padding: 4px;
  border-radius: var(--radius-lg);
  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);
}
.ext-cal-controls .ext-cal-tabs .ext-cal-tab {
  padding: 8px 18px;
  border-radius: var(--radius-md);
  border: none;
  background: transparent;
  cursor: pointer;
  font-weight: 600;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
  font-size: 0.875rem;
  color: var(--text-secondary);
  white-space: nowrap;
}
.ext-cal-controls .ext-cal-tabs .ext-cal-tab:hover {
  color: var(--text-primary);
  background: rgba(255, 255, 255, 0.5);
}
.ext-cal-controls .ext-cal-tabs .ext-cal-tab.ext-cal-tab-active {
  background: var(--primary-color);
  color: white;
  box-shadow: var(--shadow-sm);
  transform: translateY(-1px);
}
.ext-cal-controls .ext-cal-actions {
  flex: 1 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 0.75rem;
  min-width: 200px;
}

.ext-cal-options-dropdown {
  position: relative;
  display: inline-block;
}

.ext-cal-options-trigger {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  color: var(--text-secondary);
  padding: 0.625rem 1rem;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all 0.2s ease;
  font-weight: 500;
  font-size: 0.875rem;
}
.ext-cal-options-trigger:hover {
  background: var(--bg-tertiary);
  border-color: var(--primary-light);
  color: var(--text-primary);
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}
.ext-cal-options-trigger svg {
  width: 1rem;
  height: 1rem;
  transition: transform 0.2s ease;
}

.ext-cal-dropdown-arrow {
  transition: transform 0.2s ease;
}
.ext-cal-dropdown-arrow-open {
  transform: rotate(180deg);
}

.ext-cal-dropdown-menu {
  position: absolute;
  top: calc(100% + 0.5rem);
  right: 0;
  background: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
  z-index: 1000;
  min-width: 280px;
  max-width: 320px;
  overflow: hidden;
  animation: dropdownSlideIn 0.2s ease-out;
}

@keyframes dropdownSlideIn {
  from {
    opacity: 0;
    transform: translateY(-8px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
.ext-cal-dropdown-header {
  background: linear-gradient(135deg, var(--bg-tertiary), var(--bg-secondary));
  padding: 1rem 1.25rem;
  border-bottom: 1px solid var(--border-color);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}
.ext-cal-dropdown-header h4 {
  margin: 0;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-primary);
  flex: 1 1;
}

.ext-cal-dropdown-content {
  padding: 0.75rem;
  max-height: 300px;
  overflow-y: auto;
}
.ext-cal-dropdown-content::-webkit-scrollbar {
  width: 6px;
}
.ext-cal-dropdown-content::-webkit-scrollbar-track {
  background: var(--bg-tertiary);
  border-radius: 3px;
}
.ext-cal-dropdown-content::-webkit-scrollbar-thumb {
  background: var(--primary-light);
  border-radius: 3px;
}
.ext-cal-dropdown-content::-webkit-scrollbar-thumb:hover {
  background: var(--primary-color);
}

.ext-cal-field-option {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.625rem 0.5rem;
  margin-bottom: 0.25rem;
  border-radius: var(--radius-md);
  cursor: pointer;
  transition: all 0.2s ease;
}
.ext-cal-field-option:hover {
  background: var(--bg-tertiary);
}
.ext-cal-field-option:last-child {
  margin-bottom: 0;
}
.ext-cal-field-option input[type=checkbox] {
  width: 1rem;
  height: 1rem;
  border: 2px solid var(--border-color);
  border-radius: var(--radius-sm);
  background: var(--bg-primary);
  cursor: pointer;
  position: relative;
  margin: 0;
  appearance: none;
  transition: all 0.2s ease;
}
.ext-cal-field-option input[type=checkbox]:checked {
  background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));
  border-color: var(--primary-color);
}
.ext-cal-field-option input[type=checkbox]:checked::after {
  content: "✓";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 0.75rem;
  font-weight: bold;
}
.ext-cal-field-option input[type=checkbox]:hover {
  border-color: var(--primary-light);
}
.ext-cal-field-option input[type=checkbox]:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);
}

.ext-cal-field-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--text-primary);
  flex: 1 1;
  -webkit-user-select: none;
          user-select: none;
}

.ext-cal-listing {
  background: var(--bg-primary);
  padding: 2rem;
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-md);
  border: 1px solid var(--border-light);
}

.ext-cal-hearings-list,
.ext-cal-tasks-list {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.ext-cal-hearing-item,
.ext-cal-task-item {
  background: linear-gradient(135deg, #fafbff, #f0f4ff);
  transition: all 0.2s ease;
}

.ext-cal-hearing-section {
  margin-bottom: 1.5rem;
  background: var(--bg-primary);
  border-radius: var(--radius-lg);
}
.ext-cal-hearing-section:last-child {
  margin-bottom: 0;
}

.ext-cal-hearing-section-title {
  font-size: 1rem;
  font-weight: 700;
  color: var(--text-primary);
  margin: 0 0 1rem 0;
  padding-bottom: 0.75rem;
  border-bottom: 2px solid var(--bg-tertiary);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
.ext-cal-hearing-section-title::before {
  content: "";
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));
}

.ext-cal-hearing-subsection {
  margin: 1rem 0;
  padding: 1rem;
  background: var(--bg-tertiary);
  border-radius: var(--radius-md);
  border-left: 3px solid var(--secondary-color);
}
.ext-cal-hearing-subsection:first-child {
  margin-top: 0;
}
.ext-cal-hearing-subsection:last-child {
  margin-bottom: 0;
}

.ext-cal-hearing-subsection-title {
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text-primary);
  margin: 0 0 0.75rem 0;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--border-color);
}

.ext-cal-hearing-row,
.ext-cal-task-row {
  display: flex;
  margin-bottom: 0.75rem;
  align-items: flex-start;
  gap: 1rem;
}
.ext-cal-hearing-row:last-child,
.ext-cal-task-row:last-child {
  margin-bottom: 0;
}

.ext-cal-hearing-label,
.ext-cal-task-label {
  font-weight: 600;
  color: var(--text-secondary);
  min-width: 180px;
  flex-shrink: 0;
  font-size: 0.875rem;
  line-height: 1.5;
}

.ext-cal-hearing-value,
.ext-cal-task-value {
  color: var(--text-primary);
  flex: 1 1;
  word-break: break-word;
  font-size: 0.875rem;
  line-height: 1.6;
  padding: 0.25rem 0.75rem;
  background: rgba(255, 255, 255, 0.7);
  border-radius: var(--radius-sm);
  border: 1px solid var(--border-light);
}

.ext-cal-empty-message {
  color: var(--text-muted);
  text-align: center;
  padding: 3rem 0;
  font-size: 1.125rem;
  font-weight: 500;
}

.ext-cal-loading {
  text-align: center;
  padding: 2rem;
  color: var(--text-muted);
  font-style: italic;
}
.ext-cal-loading::before {
  content: "⏳";
  display: block;
  font-size: 2rem;
  margin-bottom: 0.5rem;
  animation: pulse 1.5s infinite;
}

.display-board-expbtn {
  width: 100%;
  display: flex;
  justify-content: end;
}
.display-board-expbtn .export-btn {
  cursor: pointer;
  padding: 8px 18px;
  background-color: var(--primary-color);
  color: #fff;
  border: 1px solid var(--primary-color);
  border-radius: 0.5rem;
}

@keyframes pulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.ext-cal-hearing-item,
.ext-cal-task-item {
  animation: slideIn 0.3s ease-out;
}

@media (max-width: 1024px) {
  .ext-cal-container {
    padding: 1rem;
  }
  .ext-cal-date-strip {
    justify-content: flex-start;
  }
  .ext-cal-controls {
    flex-direction: column;
    align-items: stretch;
    gap: 1rem;
  }
  .ext-cal-controls .ext-cal-sort-container {
    max-width: 100%;
    order: 3;
  }
  .ext-cal-controls .ext-cal-tabs {
    position: relative;
    left: auto;
    transform: none;
    justify-content: center;
    order: 1;
  }
  .ext-cal-controls .ext-cal-actions {
    justify-content: center;
    order: 2;
  }
}
@media (max-width: 768px) {
  .ext-cal-container {
    padding: 1rem;
  }
  .ext-cal-date-navigation {
    flex-direction: column;
    gap: 1rem;
  }
  .ext-cal-hearing-row,
  .ext-cal-task-row {
    flex-direction: column;
    gap: 0.25rem;
  }
  .ext-cal-hearing-label,
  .ext-cal-task-label {
    min-width: auto;
    font-size: 0.75rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
  .ext-cal-hearing-value,
  .ext-cal-task-value {
    margin-left: 0;
    font-size: 0.875rem;
  }
  .ext-cal-hearing-section {
    padding: 1rem;
  }
  .ext-cal-listing {
    padding: 1.5rem;
  }
  .ext-cal-dropdown-menu {
    right: auto;
    left: 0;
    min-width: 260px;
    max-width: calc(100vw - 2rem);
  }
  .ext-cal-dropdown-header {
    flex-direction: column;
    align-items: stretch;
    gap: 0.75rem;
    text-align: center;
  }
}
@media (max-width: 480px) {
  .ext-cal-date-card {
    min-width: 65px;
    padding: 1rem 0.75rem;
  }
  .ext-cal-date-day {
    font-size: 1.25rem;
  }
  .ext-cal-date-month {
    font-size: 0.6875rem;
  }
  .ext-cal-date-weekday {
    font-size: 0.625rem;
  }
}
.ext-cal-view-toggle {
  display: flex;
  gap: 0.5rem;
  margin-right: 10px;
}
.ext-cal-view-toggle .ext-cal-btn {
  padding: 0.55rem 1rem;
  border: none;
  background-color: #e9ecef;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  color: #6c757d;
  font-size: 0.85rem;
  min-width: auto;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}
.ext-cal-view-toggle .ext-cal-btn.ext-cal-btn-active {
  background-color: var(--primary-color);
  color: #f8f9fa;
}
.ext-cal-view-toggle .ext-cal-btn.ext-cal-btn-active:hover {
  background-color: var(--primary-dark);
}
.ext-cal-view-toggle .ext-cal-btn:hover:not(.ext-cal-btn-active) {
  background-color: #dee2e6;
  color: #343a40;
}

.ext-cal-table-container {
  overflow-x: auto;
  margin-top: 20px;
  border-radius: 0.5rem;
  background: var(--bg-primary);
}

.ext-cal-table {
  width: 100%;
  border-collapse: collapse;
  background-color: var(--bg-primary);
  border: 1px solid var(--border-color);
  border-radius: 0.5rem;
  overflow: hidden;
  font-size: 0.95rem;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  min-width: 800px;
}
.ext-cal-table thead {
  background-color: #f1f5f9;
}
.ext-cal-table thead th {
  text-align: left;
  padding: 1rem;
  color: #111827;
  font-weight: 600;
  font-size: 0.875rem;
  border: none;
  position: sticky;
  top: 0;
  z-index: 10;
}
.ext-cal-table tbody tr {
  background-color: #f9fafb;
}
.ext-cal-table tbody tr:last-child td {
  border-bottom: none;
}
.ext-cal-table tbody tr td {
  padding: 0.9rem 1rem;
  color: var(--text-secondary);
  border: none;
  border-bottom: 1px solid #f3f4f6;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 0.875rem;
}
.ext-cal-table tbody tr td.description-cell {
  max-width: 300px;
  white-space: normal;
  word-wrap: break-word;
}
.ext-cal-table tbody tr td:last-child {
  white-space: nowrap;
}
.ext-cal-table tbody tr td .status-badge {
  min-width: 4rem;
  padding: 0.35rem 0.7rem;
  border-radius: 0.75rem;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  transition: all 0.2s ease;
  border: none;
  display: inline-block;
}
.ext-cal-table tbody tr td .status-badge.pending {
  background: #fff3cd;
  color: #856404;
}
.ext-cal-table tbody tr td .status-badge.completed {
  background: #e8f5e8;
  color: #28a745;
}

.document-link {
  color: var(--primary-color);
  text-decoration: none;
}
.document-link:hover {
  text-decoration: underline;
  color: var(--primary-dark);
}

.ext-cal-hearings-list,
.ext-cal-tasks-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1rem;
}

.ext-cal-hearing-item,
.ext-cal-task-item {
  background: #ffffff;
}

.ext-cal-hearing-section .ext-cal-hearing-section-title {
  font-size: 1.1rem;
  font-weight: 600;
  color: #343a40;
  margin-bottom: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #e9ecef;
}

.ext-cal-hearing-row,
.ext-cal-task-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 0.5rem;
}
.ext-cal-hearing-row .ext-cal-hearing-label,
.ext-cal-hearing-row .ext-cal-task-label,
.ext-cal-task-row .ext-cal-hearing-label,
.ext-cal-task-row .ext-cal-task-label {
  font-weight: 600;
  color: #6c757d;
  min-width: 120px;
  margin-right: 1rem;
}
.ext-cal-hearing-row .ext-cal-hearing-value,
.ext-cal-hearing-row .ext-cal-task-value,
.ext-cal-task-row .ext-cal-hearing-value,
.ext-cal-task-row .ext-cal-task-value {
  color: #343a40;
  flex: 1 1;
  word-break: break-word;
}

.ext-cal-actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.ext-cal-empty-message {
  text-align: center;
  padding: 2rem;
  color: var(--text-muted);
  font-style: italic;
  background: var(--bg-primary);
  border-radius: var(--radius-md);
}

.ext-cal-loading {
  text-align: center;
  padding: 2rem;
  color: var(--text-secondary);
  background: var(--bg-primary);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-sm);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
}
.ext-cal-loading::before {
  content: "";
  display: inline-block;
  width: 16px;
  height: 16px;
  border: 2px solid var(--border-color);
  border-top: 2px solid var(--primary-color);
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
@media (max-width: 768px) {
  .ext-cal-table {
    font-size: 12px;
  }
  .ext-cal-table th, .ext-cal-table td {
    padding: 6px 4px;
  }
  .ext-cal-view-toggle {
    margin-right: 5px;
  }
  .ext-cal-view-toggle .ext-cal-btn {
    padding: 6px 8px;
  }
  .ext-cal-actions {
    flex-wrap: wrap;
    gap: 5px;
  }
  .ext-cal-table-container {
    margin-top: 10px;
  }
}
@media (max-width: 480px) {
  .ext-cal-table th, .ext-cal-table td {
    padding: 4px 2px;
    font-size: 11px;
  }
  .ext-cal-view-toggle .ext-cal-btn {
    padding: 4px 6px;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/ExtendedViewPage/ExtendedViewPage.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAChB;EACE,uBAAA;EACA,wBAAA;EACA,0BAAA;EACA,uBAAA;EACA,uBAAA;EACA,yBAAA;EACA,qBAAA;EACA,qBAAA;EACA,uBAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,4CAAA;EACA,kFAAA;EACA,oFAAA;EACA,gBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,YAAA;AACF;;AAEA;EACE,yBAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;EACA,iDAAA;EACA,mBAAA;EACA,6BAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;AACF;AACE;EACE,gCAAA;EACA,YAAA;EACA,4BAAA;AACJ;AACI;EACE,iEAAA;EACA,4BAAA;EACA,2BAAA;AACN;AAEI;EACE,wBAAA;AAAN;AAIE;EACE,6BAAA;EACA,iCAAA;EACA,4BAAA;EACA,4BAAA;AAFJ;AAII;EACE,8BAAA;EACA,kCAAA;EACA,0BAAA;EACA,2BAAA;AAFN;AAME;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,+BAAA;EACA,mBAAA;AAJJ;;AAQA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,mBAAA;EACA,eAAA;EACA,SAAA;EACA,6BAAA;EACA,oBAAA;EACA,+BAAA;EACA,4BAAA;AALF;;AAQA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;AALF;;AAQA;EACE,aAAA;EACA,WAAA;AALF;;AAQA;EACE,6BAAA;EACA,qCAAA;EACA,+BAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,iDAAA;AALF;AAOE;EACE,8BAAA;EACA,kCAAA;EACA,2BAAA;EACA,4BAAA;AALJ;AAQE;EACE,cAAA;EACA,eAAA;EACA,4BAAA;AANJ;;AAUA;EACE,aAAA;EACA,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EAEA,eAAA;EACA,6BAAA;EACA,+BAAA;EACA,4BAAA;AARF;AAUE;EACE,WAAA;AARJ;AAWE;EACE,8BAAA;EACA,kBAAA;AATJ;AAYE;EACE,gCAAA;EACA,kBAAA;AAVJ;AAYI;EACE,gCAAA;AAVN;;AAeA;EACE,6BAAA;EACA,eAAA;EACA,+BAAA;EACA,kBAAA;EACA,eAAA;EACA,iDAAA;EACA,6BAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAZF;AAcE;EACE,8BAAA;EACA,2BAAA;EACA,4BAAA;AAZJ;AAeE;EACE,gCAAA;EACA,YAAA;EACA,kCAAA;EACA,2BAAA;AAbJ;AAgBE;EACE,kCAAA;AAdJ;AAgBI;EACE,qDAAA;AAdN;;AAmBA;EACE,eAAA;EACA,gBAAA;EACA,sBAAA;EACA,cAAA;AAhBF;;AAmBA;EACE,kBAAA;EACA,gBAAA;EACA,sBAAA;EACA,YAAA;EACA,qBAAA;AAhBF;;AAmBA;EACE,oBAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;AAhBF;;AAmBA;EACE,UAAA;EACA,WAAA;EACA,8EAAA;EACA,kBAAA;EACA,cAAA;EACA,6CAAA;AAhBF;AAkBE;EACE,iBAAA;EACA,wCAAA;AAhBJ;;AAoBA;EACE,sBAAA;EACA,+BAAA;EACA,qCAAA;EACA,6BAAA;EACA,mBAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AAjBF;AAmBE;EACE,kCAAA;AAjBJ;AAoBE;EACE,aAAA;EACA,kCAAA;EACA,6CAAA;AAlBJ;;AAsBA;EACE,aAAA;EACA,YAAA;AAnBF;;AAuBA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,6BAAA;EACA,oBAAA;EACA,+BAAA;EACA,4BAAA;EACA,kBAAA;AApBF;AAsBE;EACE,SAAA;EACA,gBAAA;EACA,gBAAA;AApBJ;AAsBI;EACE,WAAA;EACA,qBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AApBN;AAwBE;EACE,kBAAA;EACA,SAAA;EACA,2BAAA;EACA,aAAA;EACA,YAAA;EACA,8BAAA;EACA,YAAA;EACA,+BAAA;EACA,+CAAA;AAtBJ;AAwBI;EACE,iBAAA;EACA,+BAAA;EACA,YAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,iDAAA;EACA,mBAAA;EACA,4BAAA;EACA,mBAAA;AAtBN;AAwBM;EACE,0BAAA;EACA,oCAAA;AAtBR;AAyBM;EACE,gCAAA;EACA,YAAA;EACA,4BAAA;EACA,2BAAA;AAvBR;AA4BE;EACE,SAAA;EACA,aAAA;EACA,yBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;AA1BJ;;AA+BA;EACE,kBAAA;EACA,qBAAA;AA5BF;;AA+BA;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,6BAAA;EACA,qCAAA;EACA,4BAAA;EACA,sBAAA;EACA,+BAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;EACA,mBAAA;AA5BF;AA8BE;EACE,8BAAA;EACA,kCAAA;EACA,0BAAA;EACA,2BAAA;EACA,4BAAA;AA5BJ;AA+BE;EACE,WAAA;EACA,YAAA;EACA,+BAAA;AA7BJ;;AAiCA;EACE,+BAAA;AA9BF;AAgCE;EACE,yBAAA;AA9BJ;;AAkCA;EACE,kBAAA;EACA,wBAAA;EACA,QAAA;EACA,6BAAA;EACA,qCAAA;EACA,+BAAA;EACA,4BAAA;EACA,aAAA;EACA,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,wCAAA;AA/BF;;AAkCA;EACE;IACE,UAAA;IACA,uCAAA;EA/BF;EAiCA;IACE,UAAA;IACA,iCAAA;EA/BF;AACF;AAkCA;EACE,4EAAA;EACA,qBAAA;EACA,4CAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAhCF;AAkCE;EACE,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,0BAAA;EACA,SAAA;AAhCJ;;AAoCA;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;AAjCF;AAmCE;EACE,UAAA;AAjCJ;AAoCE;EACE,8BAAA;EACA,kBAAA;AAlCJ;AAqCE;EACE,gCAAA;EACA,kBAAA;AAnCJ;AAqCI;EACE,gCAAA;AAnCN;;AAwCA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,wBAAA;EACA,sBAAA;EACA,+BAAA;EACA,eAAA;EACA,yBAAA;AArCF;AAuCE;EACE,8BAAA;AArCJ;AAwCE;EACE,gBAAA;AAtCJ;AAyCE;EACE,WAAA;EACA,YAAA;EACA,qCAAA;EACA,+BAAA;EACA,6BAAA;EACA,eAAA;EACA,kBAAA;EACA,SAAA;EACA,gBAAA;EACA,yBAAA;AAvCJ;AAyCI;EACE,8EAAA;EACA,kCAAA;AAvCN;AAyCM;EACE,YAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,YAAA;EACA,kBAAA;EACA,iBAAA;AAvCR;AA2CI;EACE,kCAAA;AAzCN;AA4CI;EACE,aAAA;EACA,6CAAA;AA1CN;;AA+CA;EACE,mBAAA;EACA,gBAAA;EACA,0BAAA;EACA,SAAA;EACA,yBAAA;UAAA,iBAAA;AA5CF;;AA+CA;EACE,6BAAA;EACA,aAAA;EACA,+BAAA;EACA,4BAAA;EACA,qCAAA;AA5CF;;AA+CA;;EAEE,aAAA;EACA,sBAAA;EACA,WAAA;AA5CF;;AA+CA;;EAEE,qDAAA;EACA,yBAAA;AA5CF;;AA+CA;EACE,qBAAA;EACA,6BAAA;EACA,+BAAA;AA5CF;AA8CE;EACE,gBAAA;AA5CJ;;AAgDA;EACE,eAAA;EACA,gBAAA;EACA,0BAAA;EACA,kBAAA;EACA,uBAAA;EACA,2CAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;AA7CF;AA+CE;EACE,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,8EAAA;AA7CJ;;AAiDA;EACE,cAAA;EACA,aAAA;EACA,8BAAA;EACA,+BAAA;EACA,6CAAA;AA9CF;AAgDE;EACE,aAAA;AA9CJ;AAiDE;EACE,gBAAA;AA/CJ;;AAmDA;EACE,mBAAA;EACA,gBAAA;EACA,0BAAA;EACA,qBAAA;EACA,sBAAA;EACA,4CAAA;AAhDF;;AAmDA;;EAEE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,SAAA;AAhDF;AAkDE;;EACE,gBAAA;AA/CJ;;AAmDA;;EAEE,gBAAA;EACA,4BAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;AAhDF;;AAmDA;;EAEE,0BAAA;EACA,SAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;EACA,wBAAA;EACA,oCAAA;EACA,+BAAA;EACA,qCAAA;AAhDF;;AAmDA;EACE,wBAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;AAhDF;;AAqDA;EACE,kBAAA;EACA,aAAA;EACA,wBAAA;EACA,kBAAA;AAlDF;AAoDE;EACE,YAAA;EACA,cAAA;EACA,eAAA;EACA,qBAAA;EACA,8BAAA;AAlDJ;;AAqDA;EACM,WAAA;EACA,aAAA;EACA,oBAAA;AAlDN;AAqDM;EACE,eAAA;EACA,iBAAA;EACA,sCAAA;EACA,WAAA;EACA,sCAAA;EACA,qBAAA;AAnDR;;AAuDA;EACE;IACE,UAAA;EApDF;EAsDA;IACE,YAAA;EApDF;AACF;AAwDA;EACE;IACE,UAAA;IACA,2BAAA;EAtDF;EAwDA;IACE,UAAA;IACA,wBAAA;EAtDF;AACF;AAyDA;;EAEE,gCAAA;AAvDF;;AA2DA;EACE;IACE,aAAA;EAxDF;EA2DA;IACE,2BAAA;EAzDF;EA4DA;IACE,sBAAA;IACA,oBAAA;IACA,SAAA;EA1DF;EA4DE;IACE,eAAA;IACA,QAAA;EA1DJ;EA6DE;IACE,kBAAA;IACA,UAAA;IACA,eAAA;IACA,uBAAA;IACA,QAAA;EA3DJ;EA8DE;IACE,uBAAA;IACA,QAAA;EA5DJ;AACF;AAgEA;EACE;IACE,aAAA;EA9DF;EAiEA;IACE,sBAAA;IACA,SAAA;EA/DF;EAkEA;;IAEE,sBAAA;IACA,YAAA;EAhEF;EAmEA;;IAEE,eAAA;IACA,kBAAA;IACA,yBAAA;IACA,qBAAA;EAjEF;EAoEA;;IAEE,cAAA;IACA,mBAAA;EAlEF;EAqEA;IACE,aAAA;EAnEF;EAsEA;IACE,eAAA;EApEF;EAwEA;IACE,WAAA;IACA,OAAA;IACA,gBAAA;IACA,6BAAA;EAtEF;EAyEA;IACE,sBAAA;IACA,oBAAA;IACA,YAAA;IACA,kBAAA;EAvEF;AACF;AA0EA;EACE;IACE,eAAA;IACA,qBAAA;EAxEF;EA2EA;IACE,kBAAA;EAzEF;EA4EA;IACE,oBAAA;EA1EF;EA6EA;IACE,mBAAA;EA3EF;AACF;AA+EA;EACE,aAAA;EACA,WAAA;EACA,kBAAA;AA7EF;AA+EE;EACE,qBAAA;EACA,YAAA;EACA,yBAAA;EACA,qBAAA;EACA,eAAA;EACA,yBAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,YAAA;AA7EJ;AA+EI;EACE,sCAAA;EACA,cAAA;AA7EN;AA+EM;EACE,qCAAA;AA7ER;AAiFI;EACE,yBAAA;EACA,cAAA;AA/EN;;AAqFA;EACE,gBAAA;EACA,gBAAA;EACA,qBAAA;EACA,6BAAA;AAlFF;;AAqFA;EACE,WAAA;EACA,yBAAA;EACA,mCAAA;EACA,qCAAA;EACA,qBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yCAAA;EACA,gBAAA;AAlFF;AAoFE;EACE,yBAAA;AAlFJ;AAoFI;EACE,gBAAA;EACA,aAAA;EACA,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,MAAA;EACA,WAAA;AAlFN;AAuFI;EAEG,yBAAA;AAtFP;AA4FM;EACE,mBAAA;AA1FR;AA6FM;EACE,oBAAA;EACA,4BAAA;EACA,YAAA;EACA,gCAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AA3FR;AA6FQ;EACE,gBAAA;EACA,mBAAA;EACA,qBAAA;AA3FV;AA8FQ;EACE,mBAAA;AA5FV;AAgGQ;EACE,eAAA;EACA,uBAAA;EACA,sBAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,YAAA;EACA,qBAAA;AA9FV;AAgGU;EACE,mBAAA;EACA,cAAA;AA9FZ;AAiGU;EACE,mBAAA;EACA,cAAA;AA/FZ;;AAuGA;EACE,2BAAA;EACA,qBAAA;AApGF;AAsGE;EACE,0BAAA;EACA,0BAAA;AApGJ;;AAyGA;;EAEE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AAtGF;;AAyGA;;EAEE,mBAAA;AAtGF;;AA0GE;EACE,iBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,sBAAA;EACA,gCAAA;AAvGJ;;AA2GA;;EAEE,aAAA;EACA,8BAAA;EACA,uBAAA;EACA,qBAAA;AAxGF;AA0GE;;;;EAEE,gBAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;AAtGJ;AAyGE;;;;EAEE,cAAA;EACA,SAAA;EACA,sBAAA;AArGJ;;AAwGA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AArGF;;AAyGA;EACE,kBAAA;EACA,aAAA;EACA,wBAAA;EACA,kBAAA;EACA,6BAAA;EACA,+BAAA;AAtGF;;AA2GA;EACE,kBAAA;EACA,aAAA;EACA,4BAAA;EACA,6BAAA;EACA,+BAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAxGF;AA0GE;EACE,WAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,0CAAA;EACA,kBAAA;EACA,kCAAA;AAxGJ;;AA4GA;EACE;IAAK,uBAAA;EAxGL;EAyGA;IAAO,yBAAA;EAtGP;AACF;AAyGA;EACE;IACE,eAAA;EAvGF;EAyGE;IACE,gBAAA;EAvGJ;EA2GA;IACE,iBAAA;EAzGF;EA2GE;IACE,gBAAA;EAzGJ;EA6GA;IACE,eAAA;IACA,QAAA;EA3GF;EA8GA;IACE,gBAAA;EA5GF;AACF;AA+GA;EAEI;IACE,gBAAA;IACA,eAAA;EA9GJ;EAkHA;IACE,gBAAA;EAhHF;AACF","sourcesContent":["@charset \"UTF-8\";\n:root {\n  --primary-dark: #4f46e5;\n  --primary-light: #a5b4fc;\n  --secondary-color: #10b981;\n  --accent-color: #f59e0b;\n  --text-primary: #1f2937;\n  --text-secondary: #6b7280;\n  --text-muted: #9ca3af;\n  --bg-primary: #ffffff;\n  --bg-secondary: #f8fafc;\n  --bg-tertiary: #f1f5f9;\n  --border-color: #e5e7eb;\n  --border-light: #f3f4f6;\n  --shadow-sm: 0 1px 2px 0 rgba(0, 0, 0, 0.05);\n  --shadow-md: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);\n  --shadow-lg: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05);\n  --radius-sm: 6px;\n  --radius-md: 8px;\n  --radius-lg: 12px;\n  --radius-xl: 16px;\n}\n\n.ext-cal-container {\n  padding: 2rem;\n  background: #f8f9fa;\n}\n\n.ext-cal-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.ext-cal-header-actions {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.ext-cal-btn {\n  padding: 0.625rem 1.25rem;\n  border-radius: var(--radius-md);\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  font-size: 0.875rem;\n  border: 1px solid transparent;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n.ext-cal-btn-primary {\n  background: var(--primary-color);\n  color: white;\n  box-shadow: var(--shadow-sm);\n}\n.ext-cal-btn-primary:hover {\n  background: linear-gradient(135deg, var(--primary-dark), #3730a3);\n  box-shadow: var(--shadow-md);\n  transform: translateY(-1px);\n}\n.ext-cal-btn-primary:active {\n  transform: translateY(0);\n}\n.ext-cal-btn-outline {\n  background: var(--bg-primary);\n  border-color: var(--border-color);\n  color: var(--text-secondary);\n  box-shadow: var(--shadow-sm);\n}\n.ext-cal-btn-outline:hover {\n  background: var(--bg-tertiary);\n  border-color: var(--primary-light);\n  color: var(--text-primary);\n  transform: translateY(-1px);\n}\n.ext-cal-btn-sm {\n  padding: 0.375rem 0.75rem;\n  font-size: 0.75rem;\n  font-weight: 500;\n  border-radius: var(--radius-sm);\n  white-space: nowrap;\n}\n\n.ext-cal-date-navigation {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n  gap: 1rem;\n  background: var(--bg-primary);\n  padding: 1rem 1.5rem;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n}\n\n.ext-cal-month-controls {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n}\n\n.ext-cal-date-arrows {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.ext-cal-nav-btn {\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-md);\n  padding: 0.75rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.ext-cal-nav-btn:hover {\n  background: var(--bg-tertiary);\n  border-color: var(--primary-light);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n.ext-cal-nav-btn svg {\n  width: 1.25rem;\n  height: 1.25rem;\n  color: var(--text-secondary);\n}\n\n.ext-cal-date-strip {\n  display: flex;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n  overflow-x: auto;\n  justify-content: center;\n  padding: 0.5rem;\n  background: var(--bg-primary);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n}\n.ext-cal-date-strip::-webkit-scrollbar {\n  height: 6px;\n}\n.ext-cal-date-strip::-webkit-scrollbar-track {\n  background: var(--bg-tertiary);\n  border-radius: 3px;\n}\n.ext-cal-date-strip::-webkit-scrollbar-thumb {\n  background: var(--primary-light);\n  border-radius: 3px;\n}\n.ext-cal-date-strip::-webkit-scrollbar-thumb:hover {\n  background: var(--primary-color);\n}\n\n.ext-cal-date-card {\n  background: var(--bg-primary);\n  padding: 0.7rem;\n  border-radius: var(--radius-lg);\n  text-align: center;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  border: 2px solid transparent;\n  min-width: 100px;\n  position: relative;\n  flex-shrink: 0;\n}\n.ext-cal-date-card:hover {\n  background: var(--bg-tertiary);\n  transform: translateY(-2px);\n  box-shadow: var(--shadow-md);\n}\n.ext-cal-date-card.ext-cal-selected {\n  background: var(--primary-color);\n  color: white;\n  border-color: var(--primary-color);\n  transform: translateY(-2px);\n}\n.ext-cal-date-card.ext-cal-has-data {\n  border-color: var(--primary-light);\n}\n.ext-cal-date-card.ext-cal-has-data:not(.ext-cal-selected) {\n  background: linear-gradient(135deg, #fef7ff, #f3e8ff);\n}\n\n.ext-cal-date-day {\n  font-size: 1rem;\n  font-weight: 700;\n  margin-bottom: 0.25rem;\n  color: inherit;\n}\n\n.ext-cal-date-month {\n  font-size: 0.75rem;\n  font-weight: 600;\n  margin-bottom: 0.25rem;\n  opacity: 0.9;\n  letter-spacing: 0.5px;\n}\n\n.ext-cal-date-weekday {\n  font-size: 0.6875rem;\n  opacity: 0.8;\n  margin-bottom: 0.5rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.ext-cal-date-dot {\n  width: 8px;\n  height: 8px;\n  background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));\n  border-radius: 50%;\n  margin: 0 auto;\n  box-shadow: 0 2px 4px rgba(99, 102, 241, 0.3);\n}\n.ext-cal-selected .ext-cal-date-dot {\n  background: white;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);\n}\n\n.ext-cal-select {\n  padding: 0.625rem 1rem;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--border-color);\n  background: var(--bg-primary);\n  font-size: 0.875rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-weight: 500;\n}\n.ext-cal-select:hover {\n  border-color: var(--primary-light);\n}\n.ext-cal-select:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);\n}\n\n.ext-cal-actions {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.ext-cal-controls {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 1rem;\n  margin-bottom: 1rem;\n  background: var(--bg-primary);\n  padding: 1rem 1.5rem;\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-sm);\n  position: relative;\n}\n.ext-cal-controls .ext-cal-sort-container {\n  flex: 1;\n  min-width: 200px;\n  max-width: 300px;\n}\n.ext-cal-controls .ext-cal-sort-container .ext-cal-select {\n  width: 100%;\n  padding: 0.55rem 1rem;\n  border: 1px solid #e9ecef;\n  border-radius: 0.5rem;\n  background-color: #ffffff;\n  color: #343a40;\n  font-size: 0.875rem;\n  min-width: 200px;\n}\n.ext-cal-controls .ext-cal-tabs {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  display: flex;\n  gap: 0.25rem;\n  background: var(--bg-tertiary);\n  padding: 4px;\n  border-radius: var(--radius-lg);\n  box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.05);\n}\n.ext-cal-controls .ext-cal-tabs .ext-cal-tab {\n  padding: 8px 18px;\n  border-radius: var(--radius-md);\n  border: none;\n  background: transparent;\n  cursor: pointer;\n  font-weight: 600;\n  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n  font-size: 0.875rem;\n  color: var(--text-secondary);\n  white-space: nowrap;\n}\n.ext-cal-controls .ext-cal-tabs .ext-cal-tab:hover {\n  color: var(--text-primary);\n  background: rgba(255, 255, 255, 0.5);\n}\n.ext-cal-controls .ext-cal-tabs .ext-cal-tab.ext-cal-tab-active {\n  background: var(--primary-color);\n  color: white;\n  box-shadow: var(--shadow-sm);\n  transform: translateY(-1px);\n}\n.ext-cal-controls .ext-cal-actions {\n  flex: 1;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 0.75rem;\n  min-width: 200px;\n}\n\n.ext-cal-options-dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.ext-cal-options-trigger {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  color: var(--text-secondary);\n  padding: 0.625rem 1rem;\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-weight: 500;\n  font-size: 0.875rem;\n}\n.ext-cal-options-trigger:hover {\n  background: var(--bg-tertiary);\n  border-color: var(--primary-light);\n  color: var(--text-primary);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n.ext-cal-options-trigger svg {\n  width: 1rem;\n  height: 1rem;\n  transition: transform 0.2s ease;\n}\n\n.ext-cal-dropdown-arrow {\n  transition: transform 0.2s ease;\n}\n.ext-cal-dropdown-arrow-open {\n  transform: rotate(180deg);\n}\n\n.ext-cal-dropdown-menu {\n  position: absolute;\n  top: calc(100% + 0.5rem);\n  right: 0;\n  background: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: var(--radius-lg);\n  box-shadow: var(--shadow-lg);\n  z-index: 1000;\n  min-width: 280px;\n  max-width: 320px;\n  overflow: hidden;\n  animation: dropdownSlideIn 0.2s ease-out;\n}\n\n@keyframes dropdownSlideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-8px) scale(0.95);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n.ext-cal-dropdown-header {\n  background: linear-gradient(135deg, var(--bg-tertiary), var(--bg-secondary));\n  padding: 1rem 1.25rem;\n  border-bottom: 1px solid var(--border-color);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 1rem;\n}\n.ext-cal-dropdown-header h4 {\n  margin: 0;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  flex: 1;\n}\n\n.ext-cal-dropdown-content {\n  padding: 0.75rem;\n  max-height: 300px;\n  overflow-y: auto;\n}\n.ext-cal-dropdown-content::-webkit-scrollbar {\n  width: 6px;\n}\n.ext-cal-dropdown-content::-webkit-scrollbar-track {\n  background: var(--bg-tertiary);\n  border-radius: 3px;\n}\n.ext-cal-dropdown-content::-webkit-scrollbar-thumb {\n  background: var(--primary-light);\n  border-radius: 3px;\n}\n.ext-cal-dropdown-content::-webkit-scrollbar-thumb:hover {\n  background: var(--primary-color);\n}\n\n.ext-cal-field-option {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.625rem 0.5rem;\n  margin-bottom: 0.25rem;\n  border-radius: var(--radius-md);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n.ext-cal-field-option:hover {\n  background: var(--bg-tertiary);\n}\n.ext-cal-field-option:last-child {\n  margin-bottom: 0;\n}\n.ext-cal-field-option input[type=checkbox] {\n  width: 1rem;\n  height: 1rem;\n  border: 2px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  background: var(--bg-primary);\n  cursor: pointer;\n  position: relative;\n  margin: 0;\n  appearance: none;\n  transition: all 0.2s ease;\n}\n.ext-cal-field-option input[type=checkbox]:checked {\n  background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));\n  border-color: var(--primary-color);\n}\n.ext-cal-field-option input[type=checkbox]:checked::after {\n  content: \"✓\";\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: white;\n  font-size: 0.75rem;\n  font-weight: bold;\n}\n.ext-cal-field-option input[type=checkbox]:hover {\n  border-color: var(--primary-light);\n}\n.ext-cal-field-option input[type=checkbox]:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.1);\n}\n\n.ext-cal-field-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--text-primary);\n  flex: 1;\n  user-select: none;\n}\n\n.ext-cal-listing {\n  background: var(--bg-primary);\n  padding: 2rem;\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-md);\n  border: 1px solid var(--border-light);\n}\n\n.ext-cal-hearings-list,\n.ext-cal-tasks-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.ext-cal-hearing-item,\n.ext-cal-task-item {\n  background: linear-gradient(135deg, #fafbff, #f0f4ff);\n  transition: all 0.2s ease;\n}\n\n.ext-cal-hearing-section {\n  margin-bottom: 1.5rem;\n  background: var(--bg-primary);\n  border-radius: var(--radius-lg);\n}\n.ext-cal-hearing-section:last-child {\n  margin-bottom: 0;\n}\n\n.ext-cal-hearing-section-title {\n  font-size: 1rem;\n  font-weight: 700;\n  color: var(--text-primary);\n  margin: 0 0 1rem 0;\n  padding-bottom: 0.75rem;\n  border-bottom: 2px solid var(--bg-tertiary);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n.ext-cal-hearing-section-title::before {\n  content: \"\";\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, var(--primary-color), var(--primary-dark));\n}\n\n.ext-cal-hearing-subsection {\n  margin: 1rem 0;\n  padding: 1rem;\n  background: var(--bg-tertiary);\n  border-radius: var(--radius-md);\n  border-left: 3px solid var(--secondary-color);\n}\n.ext-cal-hearing-subsection:first-child {\n  margin-top: 0;\n}\n.ext-cal-hearing-subsection:last-child {\n  margin-bottom: 0;\n}\n\n.ext-cal-hearing-subsection-title {\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text-primary);\n  margin: 0 0 0.75rem 0;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid var(--border-color);\n}\n\n.ext-cal-hearing-row,\n.ext-cal-task-row {\n  display: flex;\n  margin-bottom: 0.75rem;\n  align-items: flex-start;\n  gap: 1rem;\n}\n.ext-cal-hearing-row:last-child,\n.ext-cal-task-row:last-child {\n  margin-bottom: 0;\n}\n\n.ext-cal-hearing-label,\n.ext-cal-task-label {\n  font-weight: 600;\n  color: var(--text-secondary);\n  min-width: 180px;\n  flex-shrink: 0;\n  font-size: 0.875rem;\n  line-height: 1.5;\n}\n\n.ext-cal-hearing-value,\n.ext-cal-task-value {\n  color: var(--text-primary);\n  flex: 1;\n  word-break: break-word;\n  font-size: 0.875rem;\n  line-height: 1.6;\n  padding: 0.25rem 0.75rem;\n  background: rgba(255, 255, 255, 0.7);\n  border-radius: var(--radius-sm);\n  border: 1px solid var(--border-light);\n}\n\n.ext-cal-empty-message {\n  color: var(--text-muted);\n  text-align: center;\n  padding: 3rem 0;\n  font-size: 1.125rem;\n  font-weight: 500;\n}\n\n.ext-cal-loading {\n  text-align: center;\n  padding: 2rem;\n  color: var(--text-muted);\n  font-style: italic;\n}\n.ext-cal-loading::before {\n  content: \"⏳\";\n  display: block;\n  font-size: 2rem;\n  margin-bottom: 0.5rem;\n  animation: pulse 1.5s infinite;\n}\n\n.display-board-expbtn {\n  width: 100%;\n  display: flex;\n  justify-content: end;\n}\n.display-board-expbtn .export-btn {\n  cursor: pointer;\n  padding: 8px 18px;\n  background-color: var(--primary-color);\n  color: #fff;\n  border: 1px solid var(--primary-color);\n  border-radius: 0.5rem;\n}\n\n@keyframes pulse {\n  0%, 100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.5;\n  }\n}\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n.ext-cal-hearing-item,\n.ext-cal-task-item {\n  animation: slideIn 0.3s ease-out;\n}\n\n@media (max-width: 1024px) {\n  .ext-cal-container {\n    padding: 1rem;\n  }\n  .ext-cal-date-strip {\n    justify-content: flex-start;\n  }\n  .ext-cal-controls {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 1rem;\n  }\n  .ext-cal-controls .ext-cal-sort-container {\n    max-width: 100%;\n    order: 3;\n  }\n  .ext-cal-controls .ext-cal-tabs {\n    position: relative;\n    left: auto;\n    transform: none;\n    justify-content: center;\n    order: 1;\n  }\n  .ext-cal-controls .ext-cal-actions {\n    justify-content: center;\n    order: 2;\n  }\n}\n@media (max-width: 768px) {\n  .ext-cal-container {\n    padding: 1rem;\n  }\n  .ext-cal-date-navigation {\n    flex-direction: column;\n    gap: 1rem;\n  }\n  .ext-cal-hearing-row,\n  .ext-cal-task-row {\n    flex-direction: column;\n    gap: 0.25rem;\n  }\n  .ext-cal-hearing-label,\n  .ext-cal-task-label {\n    min-width: auto;\n    font-size: 0.75rem;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n  .ext-cal-hearing-value,\n  .ext-cal-task-value {\n    margin-left: 0;\n    font-size: 0.875rem;\n  }\n  .ext-cal-hearing-section {\n    padding: 1rem;\n  }\n  .ext-cal-listing {\n    padding: 1.5rem;\n  }\n  .ext-cal-dropdown-menu {\n    right: auto;\n    left: 0;\n    min-width: 260px;\n    max-width: calc(100vw - 2rem);\n  }\n  .ext-cal-dropdown-header {\n    flex-direction: column;\n    align-items: stretch;\n    gap: 0.75rem;\n    text-align: center;\n  }\n}\n@media (max-width: 480px) {\n  .ext-cal-date-card {\n    min-width: 65px;\n    padding: 1rem 0.75rem;\n  }\n  .ext-cal-date-day {\n    font-size: 1.25rem;\n  }\n  .ext-cal-date-month {\n    font-size: 0.6875rem;\n  }\n  .ext-cal-date-weekday {\n    font-size: 0.625rem;\n  }\n}\n.ext-cal-view-toggle {\n  display: flex;\n  gap: 0.5rem;\n  margin-right: 10px;\n}\n.ext-cal-view-toggle .ext-cal-btn {\n  padding: 0.55rem 1rem;\n  border: none;\n  background-color: #e9ecef;\n  border-radius: 0.5rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  color: #6c757d;\n  font-size: 0.85rem;\n  min-width: auto;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n.ext-cal-view-toggle .ext-cal-btn.ext-cal-btn-active {\n  background-color: var(--primary-color);\n  color: #f8f9fa;\n}\n.ext-cal-view-toggle .ext-cal-btn.ext-cal-btn-active:hover {\n  background-color: var(--primary-dark);\n}\n.ext-cal-view-toggle .ext-cal-btn:hover:not(.ext-cal-btn-active) {\n  background-color: #dee2e6;\n  color: #343a40;\n}\n\n.ext-cal-table-container {\n  overflow-x: auto;\n  margin-top: 20px;\n  border-radius: 0.5rem;\n  background: var(--bg-primary);\n}\n\n.ext-cal-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: var(--bg-primary);\n  border: 1px solid var(--border-color);\n  border-radius: 0.5rem;\n  overflow: hidden;\n  font-size: 0.95rem;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n  min-width: 800px;\n}\n.ext-cal-table thead {\n  background-color: #f1f5f9;\n}\n.ext-cal-table thead th {\n  text-align: left;\n  padding: 1rem;\n  color: #111827;\n  font-weight: 600;\n  font-size: 0.875rem;\n  border: none;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n}\n.ext-cal-table tbody tr {\n  background-color: #f9fafb;\n}\n.ext-cal-table tbody tr:last-child td {\n  border-bottom: none;\n}\n.ext-cal-table tbody tr td {\n  padding: 0.9rem 1rem;\n  color: var(--text-secondary);\n  border: none;\n  border-bottom: 1px solid #f3f4f6;\n  max-width: 200px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 0.875rem;\n}\n.ext-cal-table tbody tr td.description-cell {\n  max-width: 300px;\n  white-space: normal;\n  word-wrap: break-word;\n}\n.ext-cal-table tbody tr td:last-child {\n  white-space: nowrap;\n}\n.ext-cal-table tbody tr td .status-badge {\n  min-width: 4rem;\n  padding: 0.35rem 0.7rem;\n  border-radius: 0.75rem;\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.3px;\n  transition: all 0.2s ease;\n  border: none;\n  display: inline-block;\n}\n.ext-cal-table tbody tr td .status-badge.pending {\n  background: #fff3cd;\n  color: #856404;\n}\n.ext-cal-table tbody tr td .status-badge.completed {\n  background: #e8f5e8;\n  color: #28a745;\n}\n\n.document-link {\n  color: var(--primary-color);\n  text-decoration: none;\n}\n.document-link:hover {\n  text-decoration: underline;\n  color: var(--primary-dark);\n}\n\n.ext-cal-hearings-list,\n.ext-cal-tasks-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  margin-top: 1rem;\n}\n\n.ext-cal-hearing-item,\n.ext-cal-task-item {\n  background: #ffffff;\n}\n\n.ext-cal-hearing-section .ext-cal-hearing-section-title {\n  font-size: 1.1rem;\n  font-weight: 600;\n  color: #343a40;\n  margin-bottom: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #e9ecef;\n}\n\n.ext-cal-hearing-row,\n.ext-cal-task-row {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  margin-bottom: 0.5rem;\n}\n.ext-cal-hearing-row .ext-cal-hearing-label,\n.ext-cal-hearing-row .ext-cal-task-label,\n.ext-cal-task-row .ext-cal-hearing-label,\n.ext-cal-task-row .ext-cal-task-label {\n  font-weight: 600;\n  color: #6c757d;\n  min-width: 120px;\n  margin-right: 1rem;\n}\n.ext-cal-hearing-row .ext-cal-hearing-value,\n.ext-cal-hearing-row .ext-cal-task-value,\n.ext-cal-task-row .ext-cal-hearing-value,\n.ext-cal-task-row .ext-cal-task-value {\n  color: #343a40;\n  flex: 1;\n  word-break: break-word;\n}\n\n.ext-cal-actions {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.ext-cal-empty-message {\n  text-align: center;\n  padding: 2rem;\n  color: var(--text-muted);\n  font-style: italic;\n  background: var(--bg-primary);\n  border-radius: var(--radius-md);\n}\n\n.ext-cal-loading {\n  text-align: center;\n  padding: 2rem;\n  color: var(--text-secondary);\n  background: var(--bg-primary);\n  border-radius: var(--radius-md);\n  box-shadow: var(--shadow-sm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n}\n.ext-cal-loading::before {\n  content: \"\";\n  display: inline-block;\n  width: 16px;\n  height: 16px;\n  border: 2px solid var(--border-color);\n  border-top: 2px solid var(--primary-color);\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@media (max-width: 768px) {\n  .ext-cal-table {\n    font-size: 12px;\n  }\n  .ext-cal-table th, .ext-cal-table td {\n    padding: 6px 4px;\n  }\n  .ext-cal-view-toggle {\n    margin-right: 5px;\n  }\n  .ext-cal-view-toggle .ext-cal-btn {\n    padding: 6px 8px;\n  }\n  .ext-cal-actions {\n    flex-wrap: wrap;\n    gap: 5px;\n  }\n  .ext-cal-table-container {\n    margin-top: 10px;\n  }\n}\n@media (max-width: 480px) {\n  .ext-cal-table th, .ext-cal-table td {\n    padding: 4px 2px;\n    font-size: 11px;\n  }\n  .ext-cal-view-toggle .ext-cal-btn {\n    padding: 4px 6px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
